import { createIconComponent } from '../../factory/create-icon-component';

export const BarsIcon = createIconComponent(
  'BarsIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33408 21.0011H3.05512C2.47168 21.0011 2 20.5283 2 19.946V15.7233C2 15.1398 2.47279 14.6682 3.05512 14.6682H8.33297"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.667 3.05506V21H20.365C20.8947 21 21.3229 20.5272 21.3229 19.9449V3.05506C21.3229 2.47165 20.8937 2 20.365 2H15.625C15.0963 2 14.667 2.47276 14.667 3.05506Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6671 21.0012H8.33301V9.38923C8.33301 8.80578 8.8058 8.33411 9.38813 8.33411H14.666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
